import { useEffect } from 'react';

const useKeyPress = (targetKeys, { cb, shiftCB } = cbObj, ...args) => {

    function downHandler(event) {

        const { key, shiftKey } = event;

        const isKeyPressedTracked = targetKeys.some((trackedKey) => {

            return trackedKey === key;

        });

        const extendedArgs = [
            event,
            ...args,
        ];

        !isKeyPressedTracked
            ? null
            : shiftKey
                ? shiftCB && shiftCB.apply(null, extendedArgs)
                : cb && cb.apply(null, extendedArgs);

    }

    useEffect(() => {

        window.addEventListener('keydown', downHandler);

        return () => {

            window.removeEventListener('keydown', downHandler);

        };

    });

};

export default useKeyPress;
